import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"mb-4",attrs:{"id":"verify","fluid":"","tag":"section"}},[_c(VForm,{staticClass:"d-flex flex-column px-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }